import { connect } from 'react-redux';

import UpdateSessionPage from './UpdateSessionPage';
import { actionCreators } from '../../dux/user';

const mapDispatchToProps = {
  updateSessionHandler: actionCreators.updateSession,
};

export default connect(null, mapDispatchToProps)(UpdateSessionPage);
